import { IFileDto } from '@/shared/interfaces';
import { FileEntity } from '@/hooks/upload-files/types';

export const mapIFileDto2FileEntity = (files: IFileDto[]): FileEntity[] => {
    return files.map((file) => ({
        identifier: file.UID,
        file: new File([], file.FileName),
        fileName: file.FileName,
        isUploaded: true,
        isPending: false,
        s3Key: file.FileUrl || '',
        isFailed: false,
        guid: file.UID,
    }));
};
